import React from 'react';

type Props = {
  className?: string;
  totalCartItems?: number;
  counterClassName?: string;
};

const Icon: React.FC<Props> = ({ className, totalCartItems = 0 }) => (
  <div className="relative">
    {/* {totalCartItems > 0 && (
      <> */}
    <span className="absolute right-[-8px] top-[-6px] block h-[16px] min-w-[16px] rounded-full bg-[#dc143c] text-center text-[9px] font-light leading-[15px] text-white">
      {totalCartItems}
    </span>
    {/* </>
    )} */}
    {/* <ShoppingBagIcon className={className} stroke="#494949" /> */}
    <i className={`${className} icon icon-basket-header`}></i>
  </div>
);

export default Icon;
